import React, { createContext, useContext, useState, useCallback } from "react";
import { ThemeProvider } from "styled-components";
import { darkTheme, lightTheme, GlobalStyle } from "./theme";

const ThemeContext = createContext(null);

export function AppThemeProvider({ children }) {
  const [isDark, setIsDark] = useState(() => {
    const saved = localStorage.getItem("theme");
    if (saved) return saved === "dark";
    //    return window.matchMedia?.("(prefers-color-scheme: dark)").matches ?? true;

    // Dark par défaut à la première visite — on ne consulte plus la
    // préférence système (prefers-color-scheme), qui basculait certains
    // visiteurs en clair sans qu'ils l'aient choisi.
    return true;
  });

  const toggleTheme = useCallback(() => {
    setIsDark(d => {
      const next = !d;
      localStorage.setItem("theme", next ? "dark" : "light");
      return next;
    });
  }, []);

  const setTheme = useCallback((name) => {
    const dark = name === "dark";
    setIsDark(dark);
    localStorage.setItem("theme", name);
  }, []);

  const currentTheme = isDark ? darkTheme : lightTheme;

  return (
    <ThemeContext.Provider value={{ isDark, toggleTheme, setTheme }}>
      <ThemeProvider theme={currentTheme}>
        <GlobalStyle />
        {children}
      </ThemeProvider>
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error("useTheme must be used inside <AppThemeProvider>");
  return ctx;
}
